'use strict';

module.exports = function (ngModule) {
    // routes
    require('./routes')(ngModule);
    // controllers
    require('./controllers')(ngModule);
    require('./assets')(ngModule);
    require('./directives/index.ts')(ngModule);
}


/** WEBPACK FOOTER **
 ** ./src/landing/index.js
 **/